import { memo } from "react";
import { Button } from "antd";
import IntlMessages from "../Message/IntlMessages";
import { stringFormat } from "../../utils/common-util";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import DangerousMessage from "components/Message/DangerousMessage";
import { MasterSelector } from "redux/selector";
import BottomSheet from "components/BottomSheet";
import { MODAL_LAYER_Z_INDEX } from "const/modalLayers";

const Error = ({ code, messageId, close, actions, state, ...modalProps }) => {
  const dispatch = useDispatch();
  const isLocaleTH = useSelector(MasterSelector.isLocaleTH);
  const { message: errorMessage, params = [], extraMessages, isHttpError, type, title: errorTitle } = state ?? {};

  function _onClose() {
    actions?.onCancel && actions.onCancel(dispatch);
    close();
  }

  const isConfigErrorMessage = () => typeof errorMessage === "object";

  const renderErrorMessageByLocale = () => (
    <>
      <DangerousParagraphPreserveSpace
        html={stringFormat(isLocaleTH ? errorMessage.textTh : errorMessage.textEn, params).trim()}
      />
      <span className="ms-1">{code ? `(Code: ${code})` : ""}</span>
    </>
  );

  const hasExtraMessage = () => !!extraMessages;

  const renderExtraMessage = () =>
    extraMessages.map((message, index) => (
      <div key={index}>
        {typeof message !== "string" ? message : <DangerousParagraphPreserveSpace htmlTag="div" html={message} />}
      </div>
    ));

  const renderIcon = () => {
    switch (type) {
      // case "warning":
      // //* not implemented yet
      // case "info":
      // //* not implemented yet
      default:
        return (
          <ErrorIcon className="bg-icon">
            <i className="feather-icon icon-x"></i>
          </ErrorIcon>
        );
    }
  };

  const renderTitle = () => {
    if (errorTitle) {
      return errorTitle;
    }
    return <IntlMessages id={state?.titleMessageId ?? "global.error.header"} />;
  };

  return (
    <ErrorModalStyled
      {...modalProps}
      zIndex={MODAL_LAYER_Z_INDEX.ERROR_MODAL}
      maskClosable={true}
      onClose={_onClose}
    >
      {modalProps.visible && (
        <div className="mnc-modal-error">
          <div className="modal-mnc-head">
            <h5 className="m-0">{renderTitle()}</h5>
            <Button className="btn button-ktb-close" onClick={_onClose}>
              <i className="feather-icon icon-x"></i>
            </Button>
          </div>
          <div className="modal-mnc-body">
            {!state?.hideIcon && renderIcon()}
            {!state?.hideSubTitleMessage && (
              <h5 className="color-primary-navy-blue">
                <IntlMessages id="global.error.message.title" />
              </h5>
            )}
            {errorMessage !== null && errorMessage !== undefined ? (
              isConfigErrorMessage(errorMessage) ? (
                renderErrorMessageByLocale()
              ) : (
                <>
                  <DangerousParagraphPreserveSpace html={errorMessage} />
                  {code && <span className="ms-1">(Code: {code})</span>}
                </>
              )
            ) : !!messageId ? (
              <IntlMessages id={messageId} />
            ) : (
              <ParagraphPreserveSpace className="mb-0">
                {isHttpError ? (
                  <IntlMessages id="global.error.message.default-server" />
                ) : (
                  <IntlMessages id="global.error.message.default-client" />
                )}
              </ParagraphPreserveSpace>
            )}
            {hasExtraMessage() && renderExtraMessage()}
          </div>
          <div className="modal-mnc-footer">
            <div className="row justify-content-center">
              <div className="col-24 ps-md-2">
                <div className="d-grid">
                  <Button data-accept-btn className="btn button-ktb-main" onClick={_onClose} block>
                    <IntlMessages id="global.close" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </ErrorModalStyled>
  );
};

export default memo(Error);

const ErrorModalStyled = styled(BottomSheet)`
  .modal-mnc-head > h5 {
    font-size: 16px;
  }
`;

const ErrorIcon = styled.div`
  --shadow: 0px 6px 20px 2px var(--text-error);

  box-shadow: var(--shadow);
  -webkit-box-shadow: var(--shadow);
  -moz-box-shadow: var(--shadow);
`;

const ParagraphPreserveSpace = styled.p`
  white-space: pre-line;
`;

const DangerousParagraphPreserveSpace = ({ html, htmlTag = "span" }) => {
  return <DangerousMessage htmlTag={htmlTag} style={paragraphPreserveSpaceStyle} html={html} />;
};

const paragraphPreserveSpaceStyle = {
  whiteSpace: "pre-line",
};
